import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import "react-table/react-table.css";
import { api_url_tipos_image } from "../providers/api";

export default class TBLTiposEstabelecimento extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.columns = [
      {
        Header: "Nome",
        accessor: "nome",
        className: "center",
      },
      {
        Header: "Imagem",
        accessor: "foto_tipo",
        Cell: (props) => (
          <img
            src={api_url_tipos_image + props.value}
            height={40}
            style={{ borderRadius: 10 }}
          />
        ),
        className: "center",
      },
      {
        Header: "Ações",
        Cell: (row) => (
          <div>
            <Button
              size="sm"
              style={{ marginRight: 4 }}
              onClick={() => this.gerenciarAcoes("editar", row.row._original)}
            >
              <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
            </Button>
            <Button
              size="sm"
              variant="danger"
              onClick={() => this.gerenciarAcoes("deletar", row.row._original)}
            >
              <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
            </Button>
          </div>
        ),
        className: "center",
      },
    ];
  }

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "editar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    return (
      <ReactTable
        data={this.props.data}
        columns={this.columns}
        resizable={false}
        showPagination={this.props.showPagination}
        defaultPageSize={10}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando tipos..."
        noDataText="Nenhum tipo encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLTiposEstabelecimento.propTypes = {
  data: PropTypes.array,
  showPagination: PropTypes.bool,
  numRows: PropTypes.number,
  dataCallback: PropTypes.func,
};
